/**
 * 【KYMW1400】商品情報登録VO
 *
 * @export RegistGoodsModel
 * @class RegistGoodsModel
 */
export class RegistGoodsModel {
  /**
   * 受注コード
   */
  public orderCode = String('');

  /**
   * 媒体区分
   */
  public mediumType = String('');

  /**
   * 生協コード
   */
  public coopCode = String('');

  /**
   * ページ番号
   */
  public pageNum = Number(0);

  /**
   * セクションID
   */
  public sectionID = Number(0);

  /**
   * コマID
   */
  public komaID = Number(0);

  /**
   * 商品情報VO
   */
  public goodsInfoVOList: Array<any> = new Array<any>();
}
